import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HEADING } from '../../../../components/heading/constants/constants';
import Heading from '../../../../components/heading/Heading';
import StepperNavigation from '../../../../components/steppernavigation/StepperNavigation';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import TxTooltipWIcon from '../../../../components/tooltip/txtooltipwicon/TxTooltipWIcon';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { checkStateFilingApplicable, getFormSetting, submitBatchImportMatchedFields } from '../BatchImportSaga';
import { componentKey, resetFieldsData, updateBatchImportFormData } from '../BatchImportSlice';
import { BATCH_FORMS_LOADING_STATES } from '../constants';
import styles from './BatchImportStepper.styles.';
import EditImportData from './editimportdata/EditImportData';
import MatchFields from './matchfields/MatchFields';
import UploadFile from './uploadfile/UploadFile';

export default function BatchImportStepper() {

    const { batchImportFormData, draggableFormBoxes, mappedFields } = useSelector((state) => state[componentKey]);
    const [refreshStep, setRefreshStep] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getFormSetting({formId: batchImportFormData?.selectedForm?.FormId, year: batchImportFormData?.selectedYear ?? null}));
        dispatch(checkStateFilingApplicable({formId: batchImportFormData?.selectedForm?.FormId}));
    }, []);

    const batchImportSteps = [
        {
            title: "Upload sheet",
            stepBodyComponent: <UploadFile setRefreshStep={(idx) => setRefreshStep(idx)} />,
            footerText: "",
        },{
            title: "Match Fields",
            stepBodyComponent: <MatchFields />,
            backButtonText: "Back",
            prevCb: () => handleBackBtnToUploadScreenClk(),
            submitButtonText: "Next",
            submitButtonDisabled: false,
            submitButtonDisabledInfoCb: () => {},
            submitCb: () => handleMappingFieldsSubmitBtnClick(),
        },{
            title: "Edit Data",
            stepBodyComponent: <EditImportData />,
            backButtonText: "Back",
            prevCb: () => { },
        },
    ];

    const handleBackBtnToUploadScreenClk = () => {
        dispatch(updateBatchImportFormData({
            uploadedFile: null,
            filingForCorrected: false,
            isPreviousSavedData: null,
            goToListingStep: null,
            useUploadedFile: null,
            isUploadedDataSessionSet: null,
            pastedFileData: "",
        }));
        dispatch(resetFieldsData());
        setRefreshStep(0);
    }

    const handleMappingFieldsSubmitBtnClick = () => {
        for (let i = 0; i < draggableFormBoxes.length; i++) {
            if (!draggableFormBoxes[i].hasOwnProperty('mapped') || draggableFormBoxes[i].mapped === false) {
                dispatch(addNotifications({ heading: "Some boxes are left to be mapped", message: "Please map all boxes to excel columns", variant: TOASTER_VARIANT.DANGER }));
                return false;
            }
        }
        const mappedObject = mappedFields.reduce((acc, field) => {
            if (field?.matchedFormField && field?.matchedFormField !== null) {
                acc[field.matchedFormField.name] = field.label;
            }
            return acc;
        }, {});
          
        dispatch(submitBatchImportMatchedFields({
            formId: batchImportFormData?.selectedForm?.FormId, 
            matchedFieldsData: mappedObject, 
            year: batchImportFormData?.selectedYear ?? null, 
            quarter: batchImportFormData?.quarter,
            pageLoadingState: {
                loading: BATCH_FORMS_LOADING_STATES.MATCHING_PAGE_LOADING,
                ready: BATCH_FORMS_LOADING_STATES.MATCHING_PAGE_READY,
            }
        }))
        
        return false;
    }
    
    return <>
        
        <div style={styles.createFormContainer}>
            <div style={styles.bodyContainer}>
                <div style={styles.headerRow}>
                    <div style={styles.selectedFormInfo}>
                        <Heading type={HEADING.H1} customStyle={styles.formHeading}>
                            Bulk Import: Form {batchImportFormData?.selectedForm?.FormLabel}
                        </Heading>

                        <div style={styles.formToolTip}>
                            <TxTooltipWIcon
                                id={"batchimport-tooltip"}
                                text={"During the import, the system will apply the entered State ID in the template into the state ID box in the form. Please make sure to check that your state ID is in the correct format for each state being filed under before proceeding with submitting your forms.Our system will not verify the info for you."}
                            />
                        </div>
                    </div>
                </div>
                <div style={styles.stepperRow}>
                    <StepperNavigation steps={batchImportSteps} refreshStep={refreshStep} setRefreshStep={(idx) => setRefreshStep(idx)} />
                </div>
            </div>             
        </div>
    </>
}